import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';

const SPEC_TYPE_LABEL = {
  SELECT: '固定項目',
  INPUT: '輸入項目',
};

export const mtrSpecSideMsgBlocks = [
  {
    fields: [
      { label: '代號', value: 'code' },
      { label: '名稱', value: 'name' },
      {
        label: '類型',
        value: (row) => SPEC_TYPE_LABEL[row?.specType] || row?.specType || '-',
      },
      {
        label: '選項數',
        value: (row) => row?.optionCount ?? '-',
        condition: (row) => row?.specType === 'SELECT' || row?._source === 'select',
      },
      { label: '狀態', value: entityStatusSideMsgValue },
      { label: '備註', value: 'remark' },
    ],
  },
];
